import memoize from "fast-memoize";
import fetch from "./fetch-trade-api";

const value = async ({ accountId, trimId, miles }) => {
  const req = await fetch(
    `/v1/report/value/account/${accountId}/trim/${trimId}/miles/${miles || 0}`
  );
  const values = await req.json()
  return values;
};

export default memoize(value, {
  serializer: ({ accountId, trimId, miles }) =>
    `${accountId}-${trimId}-${miles}`
});
